import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import { basename } from "constant.js";

const apiUrl = process.env.REACT_APP_AUTH_API_URL;

function Invoice() {
  const { userId, token, eventId, invoiceId } = useParams();
  const [eventDetails, setEventDetails] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const navigate = useNavigate();

  const fetchEventDetails = async () => {
    setLoading(true);
    fetch(`${apiUrl}/event/invoice_details.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ eventId, invoiceId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message) {
          setError(data.message);
        } else {
          console.log("Invoice data:", data.invoice);
          setEventDetails(data);
          // Check if invoice is already confirmed
          if (data.event?.invoice_confirm === 1 || data.event?.invoice_confirm === "1" || data.invoice_db?.confirmed === 1 || data.invoice_db?.confirmed === "1") {
            setError("already_confirmed");
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error.message);
        setLoading(false);
      });
  };

  const handleUserResponse = async (status) => {
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/event/confirm_invoice.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId, token, eventId, invoiceId, status }),
      });

      const result = await response.json();

      if (response.ok && result.message === "Email sent successfully") {
        // Redirect to event page
        navigate(`${basename}/event/${eventId}`);
      } else {
        throw new Error(result.message || "Failed to confirm or deny the invoice.");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEventDetails();
  }, [eventId]);

  // Show thank you message if already confirmed
  if (error === "already_confirmed") {
    return (
      <DashboardLayout>
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-4}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="success"
                  borderRadius="lg"
                  coloredShadow="success"
                >
                  <MDTypography variant="h6" color="white">
                    Preventivo già approvato
                  </MDTypography>
                </MDBox>
                <MDBox mx={3} my={5} textAlign="center">
                  <Icon sx={{ fontSize: 80, color: "#4CAF50", mb: 2 }}>check_circle</Icon>
                  <MDTypography variant="h3" fontWeight="bold" color="success" mb={2}>
                    Grazie per aver approvato il preventivo!
                  </MDTypography>
                  <MDTypography variant="h6" color="text">
                    Team di PermessiOk
                  </MDTypography>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-4}
                py={3}
                px={2}
                variant="gradient"
                bgColor="secondary"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Validazione preventivo evento {eventDetails?.event?.event_name}
                </MDTypography>
              </MDBox>
              <MDBox mx={3} my={2}>
                <MDTypography variant="body1" color="text" component="div">
                  <div style={{ fontWeight: "bold", textAlign: "center", marginBottom: 16 }}>
                    INFORMATIVA PER IL TRATTAMENTO DEI DATI PERSONALI DEL SITO WEB
                  </div>
                  <div style={{ marginBottom: 16 }}>
                    <strong>EROICA S.r.l.</strong>, con sede legale in Via Lanfranco della Pila, 2, 20162, Milano (MI), Italia, P. IVA 12915520964 (in seguito “Titolare”), in qualità di Titolare del trattamento, La informa ai sensi del regolamento UE 2016/679 (“GDPR”) e della vigente normativa in materia di protezione dei dati personali che i Suoi dati, nell’ambito del presente sito web saranno trattati con le modalità e per le finalità seguenti.
                  </div>
                  <div style={{ marginBottom: 16 }}>
                    Ove non diversamente indicato, quanto contenuto nella presente informativa dovrà intendersi applicabile ai dati personali trattati nell’ambito dell’utilizzo del Sito web. Resta inteso che per i trattamenti di dati personali effettuati per finalità diverse da quelle di seguito indicate troveranno applicazione le informative sul trattamento relative ai servizi di volta in volta considerati.
                  </div>

                  <div style={{ fontWeight: "bold", marginTop: 24, marginBottom: 8 }}>
                    • TIPOLOGIE DI DATI TRATTATI
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    Riceviamo e conserviamo informazioni e le seguenti categorie di dati personali, da distinguere in qualità di titolare o responsabile del trattamento:
                  </div>
                  <ul style={{ marginBottom: 8, paddingLeft: 24, listStyleType: "disc" }}>
                    <li>
                    <strong>In qualità di Titolare del Trattamento, EROICA tratta:</strong>
                    <ul style={{ paddingLeft: 24, listStyleType: "circle" }}>
                        <li>
                        dati personali comuni raccolti dagli utenti durante l’utilizzo del Sito e, in particolare, a titolo esemplificativo: nome e cognome, numero di telefono, indirizzo e-mail, dati necessari alla registrazione di un account, dati relativi ai pagamenti, dati di navigazione (quali indirizzo IP e ID di sessione).
                        </li>
                    </ul>
                    </li>
                    <li>
                    <strong>In qualità di Responsabile del Trattamento, EROICA tratta per conto e su istruzione del cliente Titolare:</strong>
                    <ul style={{ paddingLeft: 24, listStyleType: "circle" }}>
                        <li>
                        dati personali comuni, ed eventualmente particolari, forniti dal Cliente tramite il form presente sul Sito del Responsabile o, in generale, tutti i dati personali trattati dal Responsabile per conto del Cliente nella prestazione dei servizi.
                        </li>
                    </ul>
                    </li>
                </ul>

                  <div style={{ fontWeight: "bold", marginTop: 24, marginBottom: 8 }}>
                    • FINALITÀ E BASI GIURIDICHE DEL TRATTAMENTO
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    I dati personali sono trattati per le finalità e basi giuridiche di seguito descritte:
                  </div>
                  <ul style={{ marginBottom: 8, paddingLeft: 24, listStyleType: "disc" }}>
                    <li>
                    <strong>L’adempimento di impegni contrattuali e precontrattuali ai sensi dell’art. 6(1)(b) GDPR</strong>, e in particolare per:
                    <ul style={{ paddingLeft: 24, listStyleType: "circle" }}>
                        <li>dar corso alle richieste dell’utente (a titolo esemplificativo, per la gestione delle richieste di contatto, per calcolare il preventivo richiesto dall’utente);</li>
                        <li>creare e gestire gli account sul Sito;</li>
                        <li>consentire all’utente di utilizzare il Sito, compresa la registrazione del Sito e le funzionalità connesse.</li>
                    </ul>
                    </li>
                    <li>
                    <strong>L’adempimento da parte del Titolare di obblighi di legge, regolamenti o della normativa nazionale o comunitaria ovvero imposti dalle autorità competenti ai sensi dell’art. 6(1)(c) GDPR;</strong>
                    </li>
                    <li>
                    <strong>Perseguimento di un legittimo interesse del Titolare ai sensi dell’art. 6(1)(f) GDPR</strong>, quale:
                    <ul style={{ paddingLeft: 24, listStyleType: "circle" }}>
                        <li>esercitare o difendere un diritto in giudizio od avanti un’Autorità;</li>
                        <li>garantire la manutenzione del Sito e delle sue funzioni operative, per prevenire frodi o abusi a danno del Sito, nonché per tutelare la sicurezza della navigazione e delle informazioni;</li>
                        <li>prevenire o segnalare attività fraudolente o abusi ai danni del Sito.</li>
                    </ul>
                    </li>
                </ul>
                                
                <div style={{ fontWeight: "bold", marginTop: 24, marginBottom: 8 }}>
                • MODALITÀ DEL TRATTAMENTO
                </div>
                <div style={{ marginBottom: 16 }}>
                Il trattamento dei Suoi dati è effettuato, sia in modalità cartacea che informatizzata in modo da minimizzare il rischio di distruzione, perdita (compresa la perdita accidentale), accesso/utilizzo non autorizzato o utilizzo incompatibile con la finalità iniziale della raccolta. Ciò viene conseguito con le misure di sicurezza tecniche e organizzative attuate dal Titolare.
                </div>

                <div style={{ fontWeight: "bold", marginTop: 24, marginBottom: 8 }}>
                • CONSERVAZIONE DEI DATI
                </div>
                <div style={{ marginBottom: 8 }}>
                Nel contesto dell’utilizzo del Sito, il Titolare tratta i dati personali per il tempo necessario ad adempiere alle finalità di cui alla Sezione 2 (Finalità e basi giuridiche del trattamento) e comunque:
                </div>
                <ul style={{ marginBottom: 8, paddingLeft: 24, listStyleType: "disc" }}>
                <li>
                    per l’adempimento di impegni contrattuali e precontrattuali i dati saranno conservati per tutta la durata del contratto e, successivamente, per un periodo di 10 anni decorrenti dalla cessazione del contratto;
                </li>
                <li>
                    per il tempo richiesto dalle applicabili disposizioni normative in relazione alle finalità di adempimento di obblighi di legge del Titolare.
                </li>
                </ul>

                <div style={{ fontWeight: "bold", marginTop: 24, marginBottom: 8 }}>
                • CONFERIMENTO DEI DATI
                </div>
                <div style={{ marginBottom: 8 }}>
                Nel contesto dell’utilizzo del Sito, il conferimento dei dati personali:
                </div>
                <ul style={{ marginBottom: 8, paddingLeft: 24, listStyleType: "disc" }}>
                <li>
                    per le finalità di adempimento di impegni contrattuali e precontrattuali dell’utilizzo del Sito è obbligatorio. Questi dati sono necessari per il rapporto con il Titolare e la fruizione dei servizi. L’utente può comunque decidere di non conferire i dati personali tuttavia, in assenza di questi dati personali non sarà possibile usufruire dei servizi del Titolare;
                </li>
                <li>
                    per le finalità di adempimento da parte del Titolare di obblighi di legge è obbligatorio. Tale trattamento è necessario per adempiere ad un obbligo legale al quale è soggetto il Titolare.
                </li>
                </ul>

                <div style={{ fontWeight: "bold", marginTop: 24, marginBottom: 8 }}>
                • COMUNICAZIONE DEI DATI
                </div>
                <div style={{ marginBottom: 8 }}>
                Nell’ambito delle suindicate finalità, il Titolare del trattamento potrà comunicare i Suoi dati a:
                </div>
                <ul style={{ marginBottom: 8, paddingLeft: 24, listStyleType: "disc" }}>
                <li>
                    Dipendenti e collaboratori del Titolare, debitamente istruiti e autorizzati al trattamento ai sensi degli art. 29 GDPR e 2-quaterdecies D. Lgs.196/2003;
                </li>
                <li>
                    soggetti terzi necessari per l’esecuzione delle attività connesse e conseguenti all’esecuzione del contratto (es. fornitori di servizi informatici, bancari, assicurativi, contabili, fiscali, legali, ecc.), che agiscono come responsabili o come titolari autonomi del trattamento;
                </li>
                <li>
                    autorità pubbliche giudiziarie o di polizia, nei limiti stabiliti dalle leggi applicabili.
                </li>
                </ul>
                <div style={{ marginBottom: 8 }}>
                Può richiedere al Titolare, in ogni momento, l’elenco aggiornato dei responsabili del trattamento.
                </div>
                <div style={{ fontWeight: "bold", marginTop: 24, marginBottom: 8 }}>
                • TRASFERIMENTO DEI DATI
                </div>
                <div style={{ marginBottom: 8 }}>
                Il Titolare non effettua alcun trasferimento al di fuori dello Spazio Economico Europeo. Tuttavia, qualora ciò dovesse rendersi necessario per le finalità sopra indicate, esso avverrà esclusivamente sulla base di una decisione di adeguatezza ai sensi dell’art. 45 GDPR o, in ogni caso, nel rispetto delle garanzie di cui al Capo V del GDPR.
                </div>
                <div style={{ fontWeight: "bold", marginTop: 24, marginBottom: 8 }}>
                • DIRITTI DELL’INTERESSATO
                </div>
                <div style={{ marginBottom: 8 }}>
                Il Titolare la informa che, in qualità di soggetto interessato, se non ricorrono le limitazioni previste dalla legge, Lei ha il diritto di:
                </div>
                <ul style={{ marginBottom: 8, paddingLeft: 24, listStyleType: "disc" }}>
                <li>
                    ottenere la conferma dell’esistenza o meno di Suoi dati personali, anche se non ancora registrati, e che tali dati vengano messi a Sua disposizione in forma intellegibile;
                </li>
                <li>
                    ottenere indicazione e, se del caso, copia: a) dell’origine e della categoria dei dati personali; b) della logica applicata in caso di trattamento effettuato con l’ausilio di strumenti elettronici; c) delle finalità e modalità del trattamento; d) degli estremi identificativi del Titolare e dei responsabili; e) dei soggetti o delle categorie di soggetti ai quali i dati personali possono essere comunicati o che possono venirne a conoscenza, in particolare se destinatari di paesi terzi o organizzazioni internazionali; f) quando possibile, del periodo di conservazione dei dati oppure i criteri utilizzati per determinare tale periodo; g) dell’esistenza di un processo decisionale automatizzato, e, in tal caso, delle logiche utilizzate, dell’importanza e delle conseguenze previste per l’interessato; h) dell’esistenza di garanzie adeguate in caso di trasferimento dei dati a un paese extra-UE o a un’organizzazione internazionale;
                </li>
                <li>
                    ottenere, senza ingiustificato ritardo, l’aggiornamento e la rettifica dei dati inesatti ovvero, quando vi ha interesse, l’integrazione dei dati incompleti;
                </li>
                <li>
                    revocare in ogni momento, con facilità, senza impedimenti, i consensi prestati, utilizzando, se possibile, gli stessi canali usati per il consenso;
                </li>
                <li>
                    ottenere la cancellazione, la trasformazione in forma anonima o il blocco dei dati: a) trattati illecitamente; b) non più necessari in relazione agli scopi per i quali sono stati raccolti o successivamente trattati; c) in caso di revoca del consenso su cui si basa il trattamento e in caso non sussista altro fondamento giuridico, d) qualora Lei si sia opposto al trattamento e non sussista alcun motivo legittimo prevalente per proseguire il trattamento; e) nel caso di adempimento di un obbligo legale; f) nel caso di dati riferiti a minori. Il Titolare può rifiutare la cancellazione solo nel caso di: a) esercizio del diritto alla libertà di espressione e di informazione; b) adempimento di un obbligo legale; c) motivi di interesse pubblico nel settore sanitario pubblico; d) archiviazione nel pubblico interesse, ricerca scientifica o storica o a fini statistici; e) esercizio di un diritto in sede giudiziaria;
                </li>
                <li>
                    ottenere la limitazione del trattamento nel caso di: a) contestazione dell’esattezza dei dati personali; b) trattamento illecito del Titolare per impedire la cancellazione; c) esercizio di un Suo diritto in sede giudiziaria; d) verifica dell’eventuale prevalenza dei motivi legittimi del Titolare rispetto a quelli dell’interessato;
                </li>
                <li>
                    ricevere, qualora il trattamento sia effettuato con mezzi automatizzati, senza impedimenti e in un formato strutturato, di uso comune e leggibile, i dati personali che La riguardano per trasmetterli ad altro titolare o – se tecnicamente fattibile – di ottenere che la trasmissione avvenga direttamente dal Titolare ad altro titolare;
                </li>
                <li>
                    opporsi, in tutto o in parte, per motivi legittimi, connessi alla Sua situazione particolare, al trattamento dei dati personali che La riguardano;
                </li>
                <li>
                    proporre reclamo all’Autorità Garante per la Protezione dei Dati Personali.
                </li>
                </ul>
                <div style={{ marginBottom: 8 }}>
                Nei casi di cui sopra, ove necessario, il Titolare porterà a conoscenza i soggetti terzi ai quali i Suoi dati personali sono comunicati dell’eventuale esercizio dei diritti da parte Sua, ad eccezione di specifici casi (es. quando tale adempimento si riveli impossibile o comporti un impiego di mezzi manifestamente sproporzionato rispetto al diritto tutelato). L’interessato, qualora ritenga che i propri diritti siano stati compromessi, ha diritto di proporre reclamo.
                </div>
                <div style={{ marginBottom: 8 }}>
                Per ogni informazione ulteriore, La invitiamo a consultare il sito internet dell’Autorità Garante per la protezione dei dati personali – <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">www.garanteprivacy.it</a> – dove troverà una sezione dedicata ai diritti.
                </div>
                <div style={{ fontWeight: "bold", marginTop: 24, marginBottom: 8 }}>
                • MODALITÀ DI ESERCIZIO DEI DIRITTI
                </div>
                <div style={{ marginBottom: 8 }}>
                Lei potrà, in qualsiasi momento, esercitare i suoi diritti:
                <ul style={{ marginTop: 8, paddingLeft: 24, listStyleType: 'disc' }}>
                    <li>inviando una raccomandata a.r. all’indirizzo del Titolare;</li>
                    <li>inviando una mail a <a href="mailto:eroica@contabpec.it">eroica@contabpec.it</a></li>
                </ul>
                </div>
                </MDTypography>
              </MDBox>
            </Card>
            <MDBox
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
            >
              {eventDetails?.invoice?.data?.url && (
                <MDButton
                  variant="contained"
                  color="info"
                  size="large"
                  startIcon={<Icon>download</Icon>}
                  onClick={() => window.open(eventDetails.invoice.data.url, '_blank')}
                  sx={{
                    mt: 4,
                    px: 4,
                    py: 1.5,
                    fontSize: '1.1rem',
                    fontWeight: 'bold',
                  }}
                >
                  Scarica preventivo
                </MDButton>
              )}

              <MDBox
                display="flex"
                alignItems="center"
                gap={1.5}
                mt={3}
                sx={{ maxWidth: 1200 }}
              >
                <Checkbox
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                  color="primary"
                  sx={{ 
                    transform: 'scale(1.5)',
                    '& .MuiSvgIcon-root': { 
                      fontSize: 32,
                      backgroundColor: '#ffffff',
                      borderRadius: '4px',
                      border: '2px solid #d0d0d0',
                      padding: '2px'
                    }
                  }}
                />
                <MDTypography variant="body2" color="text">
                  Ho letto e compreso le condizioni di servizio di PermessiOk
                </MDTypography>
              </MDBox>

              <MDTypography variant="h5" fontWeight="bold" mb={2}>
                Confermare o negare il costo del servizio
              </MDTypography>

              <MDBox display="flex" gap={2}>
                <MDButton
                  variant="contained"
                  color={!termsAccepted || loading ? "secondary" : "success"}
                  disabled={!termsAccepted || loading}
                  onClick={() => handleUserResponse("confirmed")}
                  sx={{
                    opacity: !termsAccepted || loading ? 0.5 : 1
                  }}
                >
                  Conferma
                </MDButton>
                <MDButton
                  variant="contained"
                  color={!termsAccepted || loading ? "secondary" : "error"}
                  disabled={!termsAccepted || loading}
                  onClick={() => handleUserResponse("denied")}
                  sx={{
                    opacity: !termsAccepted || loading ? 0.5 : 1
                  }}
                >
                  Nega
                </MDButton>
              </MDBox>

              {error && (
                <MDTypography mt={2} color="error">
                  {error}
                </MDTypography>
              )}
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Invoice;
